// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_dashLayout__b4wqd {
  display: grid;
  grid-template-columns: 280px 1fr; /* Sidebar width | Content grows */
  flex: 1 1;
  min-height: calc(100vh - 56px);
  height: calc(100vh - 56px);
  overflow: hidden;                 /* Prevent page scroll */
  background: var(--bg-secondary);
  position: relative;
  color: var(--text-primary);
}

.dashboard_dashSidebar__WlYlo {
  overflow-y: auto;                   /* Sidebar gets its own scroll */
  position: relative;
}

.dashboard_dashContent__4Mk56 {
  overflow-y: auto;                  /* Enable scroll */
  scrollbar-width: none;             /* Hide scrollbar in Firefox */
  -ms-overflow-style: none;           /* Hide scrollbar in IE/Edge */
  position: relative;
  width: auto;
  max-width: 1160px;                 /* Limit content width */
  margin: var(--space-3) auto;
  padding: var(--space-4) var(--space-4) var(--space-6);
  border-radius: var(--radius-lg);
  background: var(--bg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-xs);
}

/* Hide scrollbar in WebKit browsers */
.dashboard_dashContent__4Mk56::-webkit-scrollbar {
  display: none;
}

/* Responsive: stack on small screens */
@media (max-width: 800px) {
  .dashboard_dashLayout__b4wqd {
    grid-template-columns: 1fr;
  }
  .dashboard_dashSidebar__WlYlo {
    grid-row: 1;
    border-right: none;
    border-bottom: 1px solid var(--border);
  }
  .dashboard_dashContent__4Mk56 {
    grid-row: 2;
    margin: var(--space-3);
  }
}

@media (max-width: 480px) {
  .dashboard_dashContent__4Mk56 {
    margin: var(--space-2);
    padding: var(--space-3) var(--space-3) var(--space-5);
    border-radius: var(--radius-md);
  }
}

/* The content column stacks: one gap for every panel inside it. */
.dashboard_dashContent__4Mk56 > * + * {
  margin-top: var(--space-5);
}

.dashboard_welcome__nbEyd {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.dashboard_welcomeTitle__4yann {
  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  color: var(--text-primary);
}

/* A quiet line where a chart or a table would otherwise sit. */
.dashboard_note__I1u3R {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.dashboard_previewSidebarInner__37qcF {
  padding: var(--space-4) var(--space-3);
}

.dashboard_previewSidebarTitle__RZy3m {
  margin: 0 0 var(--space-2);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.dashboard_previewPatientList__gmtHn {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.dashboard_previewPatientBtn__wt3AM,
.dashboard_previewPatientBtnActive__9ZAPF {
  width: 100%;
  text-align: left;
  padding: 7px 10px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg);
  font: inherit;
  font-size: 0.875rem;
  cursor: pointer;
  transition: border-color var(--dur-fast) var(--ease-standard);
}

.dashboard_previewPatientBtn__wt3AM:hover {
  border-color: var(--border-dark);
}

.dashboard_previewPatientBtnActive__9ZAPF {
  border-color: var(--primary);
  background: var(--surface-brand-wash);
  font-weight: 700;
}


@media (max-width: 800px) {
  .dashboard_previewSidebarInner__37qcF {
    padding: var(--space-3) var(--gutter);
  }

  /* Sample patients side by side rather than a stacked list. */
  .dashboard_previewPatientList__gmtHn {
    flex-direction: row;
    gap: var(--space-2);
  }

  .dashboard_previewPatientList__gmtHn > li {
    flex: 1 1;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/dashboard.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,kCAAkC;EACpE,SAAO;EACP,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB,kBAAkB,wBAAwB;EAC1D,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB,oBAAoB,gCAAgC;EACpE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,mBAAmB,kBAAkB;EACrD,qBAAqB,cAAc,8BAA8B;EACjE,wBAAwB,YAAY,8BAA8B;EAClE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,kBAAkB,wBAAwB;EAC3D,2BAA2B;EAC3B,qDAAqD;EACrD,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,qDAAqD;IACrD,+BAA+B;EACjC;AACF;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;;;AAGA;EACE;IACE,qCAAqC;EACvC;;EAEA,6DAA6D;EAC7D;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@import url('../../colors.css');\n\n.dashLayout {\n  display: grid;\n  grid-template-columns: 280px 1fr; /* Sidebar width | Content grows */\n  flex: 1;\n  min-height: calc(100vh - 56px);\n  height: calc(100vh - 56px);\n  overflow: hidden;                 /* Prevent page scroll */\n  background: var(--bg-secondary);\n  position: relative;\n  color: var(--text-primary);\n}\n\n.dashSidebar {\n  overflow-y: auto;                   /* Sidebar gets its own scroll */\n  position: relative;\n}\n\n.dashContent {\n  overflow-y: auto;                  /* Enable scroll */\n  scrollbar-width: none;             /* Hide scrollbar in Firefox */\n  -ms-overflow-style: none;           /* Hide scrollbar in IE/Edge */\n  position: relative;\n  width: auto;\n  max-width: 1160px;                 /* Limit content width */\n  margin: var(--space-3) auto;\n  padding: var(--space-4) var(--space-4) var(--space-6);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-xs);\n}\n\n/* Hide scrollbar in WebKit browsers */\n.dashContent::-webkit-scrollbar {\n  display: none;\n}\n\n/* Responsive: stack on small screens */\n@media (max-width: 800px) {\n  .dashLayout {\n    grid-template-columns: 1fr;\n  }\n  .dashSidebar {\n    grid-row: 1;\n    border-right: none;\n    border-bottom: 1px solid var(--border);\n  }\n  .dashContent {\n    grid-row: 2;\n    margin: var(--space-3);\n  }\n}\n\n@media (max-width: 480px) {\n  .dashContent {\n    margin: var(--space-2);\n    padding: var(--space-3) var(--space-3) var(--space-5);\n    border-radius: var(--radius-md);\n  }\n}\n\n/* The content column stacks: one gap for every panel inside it. */\n.dashContent > * + * {\n  margin-top: var(--space-5);\n}\n\n.welcome {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.welcomeTitle {\n  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  color: var(--text-primary);\n}\n\n/* A quiet line where a chart or a table would otherwise sit. */\n.note {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.previewSidebarInner {\n  padding: var(--space-4) var(--space-3);\n}\n\n.previewSidebarTitle {\n  margin: 0 0 var(--space-2);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.previewPatientList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.previewPatientBtn,\n.previewPatientBtnActive {\n  width: 100%;\n  text-align: left;\n  padding: 7px 10px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg);\n  font: inherit;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: border-color var(--dur-fast) var(--ease-standard);\n}\n\n.previewPatientBtn:hover {\n  border-color: var(--border-dark);\n}\n\n.previewPatientBtnActive {\n  border-color: var(--primary);\n  background: var(--surface-brand-wash);\n  font-weight: 700;\n}\n\n\n@media (max-width: 800px) {\n  .previewSidebarInner {\n    padding: var(--space-3) var(--gutter);\n  }\n\n  /* Sample patients side by side rather than a stacked list. */\n  .previewPatientList {\n    flex-direction: row;\n    gap: var(--space-2);\n  }\n\n  .previewPatientList > li {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashLayout": `dashboard_dashLayout__b4wqd`,
	"dashSidebar": `dashboard_dashSidebar__WlYlo`,
	"dashContent": `dashboard_dashContent__4Mk56`,
	"welcome": `dashboard_welcome__nbEyd`,
	"welcomeTitle": `dashboard_welcomeTitle__4yann`,
	"note": `dashboard_note__I1u3R`,
	"previewSidebarInner": `dashboard_previewSidebarInner__37qcF`,
	"previewSidebarTitle": `dashboard_previewSidebarTitle__RZy3m`,
	"previewPatientList": `dashboard_previewPatientList__gmtHn`,
	"previewPatientBtn": `dashboard_previewPatientBtn__wt3AM`,
	"previewPatientBtnActive": `dashboard_previewPatientBtnActive__9ZAPF`
};
export default ___CSS_LOADER_EXPORT___;
